/**
 * Evidence Contract — Typed API contract for evidence synthesis and claims.
 *
 * BACKEND ALIGNMENT:
 * - All response types derived from generated Zod schemas (OpenAPI-first)
 * - Request/pagination types are hand-written (frontend-composed)
 * - All timestamps are ISO 8601 strings
 *
 * MIGRATION NOTE:
 * Zod schemas are re-exported from auto-generated code (@hey-api/openapi-ts).
 * Types inferred from generated schemas. UI-only constructs remain hand-written.
 */

import { z } from 'zod';
import type { PaginatedResponse } from './shared';

// ─── Re-exported generated schemas (single source of truth) ─────────────────

import {
  zEvidenceTypeBucket as GeneratedEvidenceTypeBucket,
  zDirectionBucket as GeneratedDirectionBucket,
  zTopClaimRead as GeneratedTopClaimRead,
  zEvidenceSynthesisRead as GeneratedEvidenceSynthesisRead,
  zClaimRowRead as GeneratedClaimRowRead,
} from '@/api/generated/hey-api/zod.gen';

export const EvidenceTypeBucketSchema = GeneratedEvidenceTypeBucket;
export type EvidenceTypeBucket = z.infer<typeof EvidenceTypeBucketSchema>;

export const DirectionBucketSchema = GeneratedDirectionBucket;
export type DirectionBucket = z.infer<typeof DirectionBucketSchema>;

export const TopClaimReadSchema = GeneratedTopClaimRead;
export type TopClaimRead = z.infer<typeof TopClaimReadSchema>;

export const EvidenceSynthesisReadSchema = GeneratedEvidenceSynthesisRead;
export type EvidenceSynthesisRead = z.infer<typeof EvidenceSynthesisReadSchema>;

export const ClaimRowReadSchema = GeneratedClaimRowRead;
export type ClaimRowRead = z.infer<typeof ClaimRowReadSchema>;

// ─── Hand-written: request types & UI-only constructs ───────────────────────

export interface ClaimsListParams {
  evidenceType?: string;
  effectDirection?: string;
  page?: number;
  pageSize?: number;
}

export type ClaimsListResponse = PaginatedResponse<ClaimRowRead>;
